import { Component, OnInit } from '@angular/core';
import { ApiHttpService } from 'src/app/services/api-http.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { IDashboardFilter } from '../filter/filter.model';
import { FilterService } from '../filter/filter.service';
import { forkJoin } from 'rxjs';
import { IArea } from 'src/app/models/area.model';
import { ICountry } from 'src/app/models/country.model';
import { ScreensEnum } from 'src/app/enums/screens.enum';
import { RightsEnum } from 'src/app/enums/rights.enum';
import { FilterComponent } from '../filter/filter.component';
import { IDashboard } from './dashboard.model';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {


      //User Orgs
  //userOrgs: any[] = [];
  //User selections
  //userAreas: IArea[] = [];
  //userCountries: ICountry[] = [];

  //dashboardData: IDashboard;

   //Filters Modal
   filtersShownOnce = false;
   showFilters = false;

   //Filters Panel
   minimizeAppliedFilters:boolean = false;
   filter: IDashboardFilter;
   //activeFilters: DashboardFilter;
   //worldWide: boolean = false;


  constructor(private _filterService: FilterService
    , private _http: ApiHttpService
    , public _auth: PermissionsService) {}

  ngOnInit() {

    // if(this.canViewDashboard()) {
    //   forkJoin([
    //     this._filterService.getUserOrgs()
    //   ]).subscribe(
    //     (data: any[]) => {
    //         console.log("user orgs", data);
    //         this.userOrgs = data[0];
    //         this.worldWide = data[0].worldWide || false;
    //         if (this.worldWide !== true) {
    //           this.userAreas = this.userOrgs['areas'];
    //           this.userCountries = this.userOrgs['countries'];
    //         }
    //     }
    //   );

      // const userAreaIds = this.userAreas.map(function (obj) { return parseInt(obj.id); });
      // const userCountryCodes = this.userCountries.map(function (obj) { return obj.countryCode; });

      // //Build our starting filter
      // this.filter = {
      //     worldWide: false,
      //     areaIds: userAreaIds,
      //     countryCodes: userCountryCodes,
      //     localLevels: [],
      //     customerNumbers: [],
      //     pl: null,
      //     sns: [],
      //     algorithmIds: [],
      //     algorithmIndicatorIds: [],
      //     suppression: [],
      //     ticketType: [],
      //     startDate: (d => new Date(d.setDate(d.getDate() - 7)))(new Date),
      //     endDate: new Date()
      // };

      //Add all the areas to the filter that are not in areas but a country is apart of that area
      // for (let country of this.filter.countries) {
      //     if (this.filter.areas.findIndex(a => a.id == country.area.id) == -1) {
      //         this.filter.areas.push(country.area);
      //     }
      // }

      //Set the active filter
      //this.activeFilters = FilterComponent.copyFilters(this.filter);

      //console.log('Active Filters', this.activeFilters);

      //Query for the chartgrid data & get our GSR Ticket URL
      //this.queryData();
    //}
  }

  public labelContent(e: any): string {
    return e.category;
  }

  closeFilters() {
    this.showFilters = false;
    document.body.className = '';
  }

  editFilters() {
    this.showFilters = true;

    if (!this.filtersShownOnce) {
        this.filtersShownOnce = true;
    }
    document.body.className = 'modal-open';
  }

  handleFilterChanged(filter: IDashboardFilter) {
    // console.log('filter changed event', filter);
    //this.activeFilters = filter;
    //this.queryData();
  }

  processData() {
    // this.pdMDetectionRate.chartConfig.chartData = this.dashboardData.chartPdmDetectionRate;
    // this.pdMDetectionRate.gridData = this.dashboardData.gridPdmDetectionRate;

    // this.unhealthyInstruments.chartConfig.chartData = this.dashboardData.chartUnhealthyInstruments;
    // this.unhealthyInstruments.gridData = this.dashboardData.gridUnhealthyInstruments;

    // this.notificationTypes.chartConfig.chartData = this.dashboardData.chartNotificationTypes;
}

  canViewDashboard(): boolean {
    return this._auth.hasPermission(ScreensEnum.Dashboard, RightsEnum.View);
  }

}

